import React from "react";
import PropTypes from "prop-types";

const IcoMoon = ({ size, color, name, className }) => {
  const classes = `icon icon-${name} ${className ? className : ""}`;
  let style = {
    margin: 0
  };

  if (color) {
    style.color = color;
  }

  if (size) {
    // calculate icon size
    if (typeof size === "number") {
      // size entered as fixed pixels
      style.fontSize = `${size}px`;
    } else {
      let fontSize = 15;
      switch (size) {
        case "huge":
          fontSize = 40;
          break;
        case "big":
          fontSize = 30;
          break;
        case "medium":
          fontSize = 20;
          break;
        case "small":
          fontSize = 15;
          break;
        case "extrasmall":
          fontSize = 13;
          break;
        default:
          break;
      }
      style.fontSize = `${fontSize}px`;
    }
  }

  return <i className={classes} style={style} />;
};

IcoMoon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string.isRequired
};

export default IcoMoon;



// WEBPACK FOOTER //
// ./src/components/common/IcoMoon/IcoMoon.js